import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import Layout from '@/pages/Layout'
import OrderSearch from '@/pages/OrderSearch'
import Press from '@/pages/Press'
import OrderSearchResult from '@/pages/OrderSearchResult'
import My from '@/pages/My'
import MyInfo from '@/pages/MyInfo'
import MyOrder from '@/pages/MyOrder'
import Apply2Refund from '@/pages/Apply2Refund'
import PressResult from '@/pages/PressResult'
import PressSubmit from '@/pages/PressSubmit'
import Library from '@/pages/Library'
import RefundList from '@/pages/RefundList'
import MyOrderAdmin from '@/pages/MyOrderAdmin'
import OrderSearchAdmin from '@/pages/OrderSearchAdmin'
import MyOrderPerson from '@/pages/MyOrderPerson'

// ===== test =======
import Test from '@/pages/Test'

// ===========

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', component: Home, name: '首页' },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '/ordersearch', component: OrderSearch, name: '订单查询' },
        { path: '/press', component: Press, name: '出版社数据' },
        { path: '/ordersearchresult', component: OrderSearchResult, name: '订单列表' },
        { path: '/my', component: My, name: '个人中心' },
        { path: '/myinfo', component: MyInfo, name: '我的资料' },
        { path: '/myorder/:type', component: MyOrder, name: '我的订单' },
        { path: '/apply2refund', component: Apply2Refund, name: '申请退款' },
        { path: '/pressresult', component: PressResult, name: '出版社数据' },
        { path: '/presssubmit', component: PressSubmit, name: '订单提交' },
        { path: '/library', component: Library, name: '图书馆' },
        { path: '/refundlist', component: RefundList, name: '退款列表' },
        { path: '/myorderadmin', component: MyOrderAdmin, name: '我的订单' },
        { path: '/ordersearchadmin', component: OrderSearchAdmin, name: '订单查询' },
        { path: '/myorderperson', component: MyOrderPerson, name: '选择退款订单' },
      ]
    },

    //  ========= test ===========
    { path: '/test', component: Test }
    // ===================

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js